import PropTypes from "prop-types";
import icon from "./Tie_Vote_Icon.svg"

/**
 * 
 * Displays the voting result for an agenda item
 * 
 */

export function TieVoteIcon({ size }) {
  return (
    <img src={icon} style={{width: size, height: size}} />
  );
}

TieVoteIcon.propTypes = {
  size: PropTypes.string
};
